import { bindRequestLogic } from './utils'
import PerTypes from '../actionTypes/per'
import { perAPI } from '../api'

const getPers = bindRequestLogic({
  clientFunc: perAPI.getPers,
  type: PerTypes.GET_PERS_REQUEST,
  successType: PerTypes.GET_PERS_SUCCESS,
  failType: PerTypes.GET_PERS_FAILED,
  isQueryParam: true
})

const getPerCurrentData = bindRequestLogic({
  clientFunc: perAPI.getPerCurrentData,
  type: PerTypes.GET_PER_CURRENT_DATA_REQUEST,
  successType: PerTypes.GET_PER_CURRENT_DATA_SUCCESS,
  failType: PerTypes.GET_PER_CURRENT_DATA_FAILED
})

const addPer = bindRequestLogic({
  clientFunc: perAPI.addPer,
  type: PerTypes.ADD_PER_REQUEST,
  successType: PerTypes.ADD_PER_SUCCESS,
  failType: PerTypes.ADD_PER_FAILED
})

const getPerBy = bindRequestLogic({
  clientFunc: perAPI.getPerBy,
  type: PerTypes.GET_PER_DETAIL_REQUEST,
  successType: PerTypes.GET_PER_DETAIL_SUCCESS,
  failType: PerTypes.GET_PER_DETAIL_FAILED
})

const updatePer = bindRequestLogic({
  clientFunc: perAPI.updatePer,
  type: PerTypes.UPDATE_PER_REQUEST,
  successType: PerTypes.UPDATE_PER_SUCCESS,
  failType: PerTypes.UPDATE_PER_FAILED
})

const deletePer = bindRequestLogic({
  clientFunc: perAPI.deletePer,
  type: PerTypes.DELETE_PER_REQUEST,
  successType: PerTypes.DELETE_PER_SUCCESS,
  failType: PerTypes.DELETE_PER_FAILED
})

const getSystemPers = bindRequestLogic({
  clientFunc: perAPI.getSystemPers,
  type: PerTypes.GET_SYSTEM_PERS_REQUEST,
  successType: PerTypes.GET_SYSTEM_PERS_SUCCESS,
  failType: PerTypes.GET_SYSTEM_PERS_FAILED,
  isQueryParam: true
})

const getPerAlerts = bindRequestLogic({
  clientFunc: perAPI.getPerAlerts,
  type: PerTypes.GET_PER_ALERTS_REQUEST,
  successType: PerTypes.GET_PER_ALERTS_SUCCESS,
  failType: PerTypes.GET_PER_ALERTS_FAILED,
  isQueryParam: true
})

const publishIOTService = bindRequestLogic({
  clientFunc: perAPI.publishIOTService,
  type: PerTypes.PUBLISH_IOT_SERVICE_REQUEST,
  successType: PerTypes.PUBLISH_IOT_SERVICE_SUCCESS,
  failType: PerTypes.PUBLISH_IOT_SERVICE_FAILED
})

const getPerPackageLogs = bindRequestLogic({
  clientFunc: perAPI.getPerPackageLogs,
  type: PerTypes.GET_PER_PACKAGE_LOGS_REQUEST,
  successType: PerTypes.GET_PER_PACKAGE_LOGS_SUCCESS,
  failType: PerTypes.GET_PER_PACKAGE_LOGS_FAILED,
  isQueryParam: true
})

const getVehicleTrips = bindRequestLogic({
  clientFunc: perAPI.getVehicleTrips,
  type: PerTypes.GET_VEHICLE_TRIPS_REQUEST,
  successType: PerTypes.GET_VEHICLE_TRIPS_SUCCESS,
  failType: PerTypes.GET_VEHICLE_TRIPS_FAILED,
  isQueryParam: true
})

const getVehicleTripBy = bindRequestLogic({
  clientFunc: perAPI.getVehicleTripBy,
  type: PerTypes.GET_VEHICLE_TRIP_DETAIL_REQUEST,
  successType: PerTypes.GET_VEHICLE_TRIP_DETAIL_SUCCESS,
  failType: PerTypes.GET_VEHICLE_TRIP_DETAIL_FAILED
})

const exportVehicleTripBy = bindRequestLogic({
  clientFunc: perAPI.exportVehicleTripBy,
  type: PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_REQUEST,
  successType: PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_SUCCESS,
  failType: PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_FAILED
})

const getCompanyPersLinked = bindRequestLogic({
  clientFunc: perAPI.getCompanyPersLinked,
  type: PerTypes.GET_COMPANY_PERS_LINKED_REQUEST,
  successType: PerTypes.GET_COMPANY_PERS_LINKED_SUCCESS,
  failType: PerTypes.GET_COMPANY_PERS_LINKED_FAILED
})

const getPersKitConfiguration = bindRequestLogic({
  clientFunc: perAPI.getPersKitConfiguration,
  type: PerTypes.GET_PERS_KIT_CONFIGURATION_REQUEST,
  successType: PerTypes.GET_PERS_KIT_CONFIGURATION_SUCCESS,
  failType: PerTypes.GET_PERS_KIT_CONFIGURATION_FAILED
})

const getMqttMessageLogs = bindRequestLogic({
  clientFunc: perAPI.getMqttMessageLogs,
  type: PerTypes.GET_MQTT_MESSAGE_LOGS_REQUEST,
  successType: PerTypes.GET_MQTT_MESSAGE_LOGS_SUCCESS,
  failType: PerTypes.GET_MQTT_MESSAGE_LOGS_FAILED
})

const getDownloadableFirmwareVersions = bindRequestLogic({
  clientFunc: perAPI.getDownloadableFirmwareVersions,
  type: PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_REQUEST,
  successType: PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_SUCCESS,
  failType: PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_FAILED
})

const getDownloadableKitConfigurationVersions = bindRequestLogic({
  clientFunc: perAPI.getDownloadableKitConfigurationVersions,
  type: PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_REQUEST,
  successType: PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_SUCCESS,
  failType: PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_FAILED
})

const prepareEncryption = bindRequestLogic({
  clientFunc: perAPI.prepareEncryption,
  type: PerTypes.PREPARE_ENCRYPTION_REQUEST,
  successType: PerTypes.PREPARE_ENCRYPTION_SUCCESS,
  failType: PerTypes.PREPARE_ENCRYPTION_FAILED
})

const downloadCipheredFirmware = bindRequestLogic({
  clientFunc: perAPI.downloadCipheredFirmware,
  type: PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_REQUEST,
  successType: PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_SUCCESS,
  failType: PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_FAILED,
  isQueryParam: true
})

export default [
  getPers,
  getPerCurrentData,
  addPer,
  updatePer,
  deletePer,
  getPerBy,
  getSystemPers,
  getPerAlerts,
  publishIOTService,
  getPerPackageLogs,
  getVehicleTrips,
  getVehicleTripBy,
  exportVehicleTripBy,
  getCompanyPersLinked,
  getPersKitConfiguration,
  getMqttMessageLogs,
  getDownloadableFirmwareVersions,
  getDownloadableKitConfigurationVersions,
  prepareEncryption,
  downloadCipheredFirmware
]
